module.exports = __webpack_public_path__ + "static/media/Poleodomia.0ce450c4.png";